"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatform = exports.Platform = void 0;
var Platform;
(function (Platform) {
    Platform[Platform["Browser"] = 0] = "Browser";
    Platform[Platform["BrowserNoWorker"] = 1] = "BrowserNoWorker";
    Platform[Platform["Server"] = 2] = "Server";
})(Platform = exports.Platform || (exports.Platform = {}));
const getPlatform = () => {
    var _a;
    if (typeof window === 'undefined') {
        return Platform.Server;
    }
    if (!((_a = navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller)) {
        return Platform.BrowserNoWorker;
    }
    return Platform.Browser;
};
exports.getPlatform = getPlatform;
